// extracted by mini-css-extract-plugin
export default {"container":"_964eb654367eb6d2","header":"_35dc820e85f2b0de","body":"cf3f19be5a34ea90"};